import DialogArticle from '@/components/dialog-article';

export default function ImprintDialog() {
  return (
    <DialogArticle>
      <h1 className='h1'>Kontakt</h1>
      <p className='p'>
        Haben Sie eine Frage zum Thema Verkehrsrecht?
        <br />
        Gerne helfen wir Ihnen weiter - zum Beispiel mit einer kostenlosen Erstberatung.
      </p>
      <p className='p'>Sie erreichen uns:</p>
      <ul className='ul'>
        <li style={{ paddingBottom: 10 }}>
          Mo-Do 8:30-17:00 Uhr Uhr und Fr 8:30-16:00 Uhr telefonisch unter:
          <span className='span tel tracking_tn'>030 2555 858 00</span>
        </li>
        <li className='li'>Per E-Mail jederzeit unter: info@wbs.legal</li>
      </ul>
      <p className='p'>
        Rückrufe auf Anfragen über unseren{' '}
        <a className='a' href='https://bussgeldcheck.wbs.legal'>
          Online-Bußgeldcheck
        </a>{' '}
        finden Mo-Fr 7:00-21:00 Uhr und Sa 9:00-17:30 Uhr statt.
      </p>
      <hr className='hr' />
      <h1 className='h1'>Impressum</h1>
      <p className='p'>
        <b className='b'>WBS.LEGAL Rechtsanwaltsgesellschaft mbH & Co. KG</b>
      </p>
      <p className='p'>
        <b className='b'>Anschrift:</b> Eupener Straße 67, 50933 Köln
        <br />
        <b className='b'>E-Mail:</b> info@wbs.legal
        <br />
        <b className='b'>Telefonnummer:</b> 0221-97 30 10-0
      </p>
      <p className='p'>
        <b className='b'>Geschäftsführer:</b> Christian Solmecke, Kilian Kost, Jeremy Gartner
        <br />
        <b className='b'>Registereintrag:</b> AG Köln, HRA 37414
        <br />
        <b className='b'>USt-ID:</b>DE122746111
      </p>
      <p className='p'>
        <b className='b'>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b> Christian Solmecke
      </p>
      <h2 className='h2'>Datenweiterleitung</h2>
      <p className='p'>
        Um Ihnen als Besucher eine hohe Beratungsqualität zu gewährleisten, leiten wir Anfragen aus unserem
        Kontaktformular nach Ihrer Einwilligung zur Datenverarbeitung zum Zweck einer kostenlosen Erstberatung an die
        erfahrenen Anwälte von SOS-Verkehrsrecht weiter:
      </p>
      <p className='p'>
        <b className='b'>SOS Verkehrsrecht</b>
        <br />
        rightmart Berlin Rechtsanwaltsgesellschaft mbH
        <br />
        Greifswalder Straße 207
        <br />
        10405 Berlin
        <br />
        E-Mail kanzlei@sos-verkehrsrecht.de
        <br />
        Vollständiges Impressum unter:{' '}
        <a className='a' href='https://sos-verkehrsrecht.de/bussgeldcheck/#impressum'>
          https://sos-verkehrsrecht.de/
        </a>
      </p>
      <p className='p'>
        Vor Abschicken des Formulars wird innerhalb der Einwilligung zur Datenweitergabe darauf hingewiesen.
      </p>
      <h2 className='h2'>Hinweise zur Berufshaftpflichtversicherung:</h2>
      <p className='p'>
        Markel International Insurance Company Limited
        <br />
        Niederlassung für Deutschland
        <br />
        Sophienstraße 26
        <br />
        80333 München
        <br />
        Der räumliche Geltungsbereich des Versicherungsschutzes umfasst Tätigkeiten in den Mitgliedstaaten der
        Europäischen Union.
      </p>
      <h2 className='h2'>Zuständige Aufsichtsbehörde (iSv. § 5 Abs. 1 Nr. 3 DDG)</h2>
      <p className='p'>
        Rechtsanwaltskammer Köln
        <br />
        Riehler Strasse 30
        <br />
        50668 Köln
        <br />
        Tel. 0221-97 30 10-0
        <br />
        Fax. 0221-97 30 10-50
        <br />
        E-Mail: kontakt@rak-koeln.de
        <br />
      </p>
      <p className='p'>
        Die Berufsbezeichnung „Rechtsanwalt“ bzw. „Rechtsanwältin“ sowie Fachanwaltsbezeichnungen wurden in der
        Bundesrepublik Deutschland verliehen.
        <br />
        Mitglied der Rechtsanwaltskammer Köln.
      </p>
      <h2 className='h2'>Berufsrechtliche Regelungen</h2>
      <p className='p'>Es gelten folgende berufsrechtliche Regelungen:</p>
      <ul className='ul'>
        <li className='li'>Berufsordnung für Rechtsanwälte (BORA)</li>
        <li className='li'>Bundesrechtsanwaltsordnung (BRAO)</li>
        <li className='li'>Fachanwaltsordnung (FAO)</li>
        <li className='li'>Rechtsanwaltsvergütungsgesetz (RVG)</li>
        <li className='li'>Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE)</li>
      </ul>
      <p className='p'>
        Den genauen Inhalt der berufsrechtlichen Regelungen für Rechtsanwälte finden Sie auf der Internetseite der
        Bundesrechtsanwaltskammer: www.brak.de unter der Rubrik “Berufsrecht” (
        <a className='a' href='http://www.brak.de/fuer-anwaelte/berufsrecht/'>
          www.brak.de/fuer-anwaelte/berufsrecht
        </a>
        ).
      </p>
      <h2 className='h2'>Aufsichtsbehörde (iSv. § 5 Abs. 1 Nr. 8 DDG)</h2>
      <p className='p'>
        Landesanstalt für Medien NRW
        <br />
        Link: www.medienanstalt-nrw.de
        <br />
        Sitzland: Deutschland
      </p>
      <h2 className='h2'>Haftungsausschluss</h2>
      <h3 className='h3'>Inhalt des Onlineangebots:</h3>
      <p className='p'>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
        nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
        Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
        Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>
      <p className='p'>
        Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der
        bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder
        ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die
        Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen,
        sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.
      </p>
      <h3 className='h3'>Verweise und Links:</h3>
      <p className='p'>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
        können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
        stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
        Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
        Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Links umgehend entfernen.
      </p>
      <h3 className='h3'>Urheberrechte:</h3>
      <p className='p'>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
        des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und
        Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
        dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
        Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
        werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Inhalte umgehend entfernen.
      </p>
    </DialogArticle>
  );
}
